import { type Column, type ColumnDef } from "@tanstack/react-table";

import { SEARCHABLE_TRADER_FIELDS } from "./constants";
import { type TraderColumnMeta, type TraderListItem } from "./types";

export const getColumnMeta = (columnDef: ColumnDef<TraderListItem, unknown>) =>
  columnDef.meta as TraderColumnMeta | undefined;

export const getColumnSortAria = (column: Column<TraderListItem, unknown>) => {
  const sortDirection = column.getIsSorted();

  if (sortDirection === "asc") {
    return "ascending";
  }

  if (sortDirection === "desc") {
    return "descending";
  }

  return undefined;
};

const normalizeSearchValue = (value: string) => value.trim().toLocaleLowerCase();

export const getTraderId = (trader: TraderListItem) =>
  trader.id === undefined || trader.id === null ? undefined : trader.id;

export const getTraderName = (trader: TraderListItem) => trader.name?.trim() || "";

export const getTraderArea = (trader: TraderListItem) =>
  trader.location_name?.trim() || trader.location_details?.name?.trim() || "";

export const getFiniteNumber = (value: number | null | undefined) => {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  return undefined;
};

export const getLastActiveTimestamp = (trader: TraderListItem) => {
  if (!trader.last_active) {
    return undefined;
  }

  const timestamp = new Date(trader.last_active).getTime();
  return Number.isNaN(timestamp) ? undefined : timestamp;
};

export const filterTraders = (traders: TraderListItem[], searchTerm?: string) => {
  const query = normalizeSearchValue(searchTerm ?? "");

  if (!query) {
    return traders;
  }

  return traders.filter(trader =>
    SEARCHABLE_TRADER_FIELDS.some(field =>
      normalizeSearchValue(trader[field] ?? "").includes(query)
    )
  );
};

export const getTraderRowId = (trader: TraderListItem, index: number) => {
  const traderId = getTraderId(trader);

  if (traderId !== undefined) {
    return String(traderId);
  }

  return `${index}-${getTraderName(trader)}-${getTraderArea(trader)}`;
};
